<template>
  <EvaluatorLayout
    title="Vagas"
    menu="Vagas"
    :customStyle="{ backgroundColor: '#fcfcfc' }"
  >
    <div class="row mb-2">
      <div class="col-lg-12 col-xs-12 pr-2">
        <div class="block_info_white p-2">
          <div class="row">
            <div class="col-lg-2 col-xs-12">
              <div class="form-group color-dark-purple mb-0">
                <h3>VAGAS</h3>
              </div>
            </div>
            <div class="col-lg-7"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-xs-12 d-flex mt-0 pt-0">
        <div class="col-lg-6 col-xs-12"></div>
        <div class="col-lg-6"></div>
      </div>
      <div class="col-lg-12 col-xs-12">
        <div
          class="tab-content"
          id="myTabContent"
        >
          <div
            class="tab-pane fade show active"
            id="home"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <div class="row">
              <div class="col-lg-12">
                <table class="table_jovool">
                  <thead class="headerTable">
                    <tr>
                      <td>
                        TÍTULO DA VAGA
                        <OrderTable
                          field="title"
                          entity="job"
                        />
                      </td>
                      <td class="center">CANDIDATO(A)S</td>
                      <td class="center">
                        DATA DE CRIAÇÃO
                        <OrderTable
                          field="created_at"
                          entity="job"
                          pre_order="desc"
                        />
                      </td>
                      <td class="center">
                        RECRUTADOR(A)
                        <OrderTable
                          entity="job"
                          field="recruiter_name"
                        />
                      </td>
                    </tr>
                  </thead>
                  <tbody class="position-relative">
                    <tr
                      v-for="job in jobs"
                      :key="job.id"
                      :class="{ 'content-loading': loading }"
                    >
                      <td
                        style="max-width: 400px"
                        class="text-truncate"
                      >
                        <inertia-link :href="`/recruiters/evaluators/jobs/${job.id}/applies`">
                          <b class="color-grey-primary text-truncate">{{
                            job.title
                          }}</b>
                        </inertia-link>
                        <br />
                        <p
                          style="margin-top: -10px"
                          class="mb-0"
                        >
                          <span class="small-text">{{
                            job.minimum_remuneration
                              | currency("R$ ", 2, {
                                decimalSeparator: ",",
                                thousandsSeparator: ".",
                              })
                          }}</span>
                          <span
                            class="small-text"
                            v-show="job.maximum_remuneration != 0"
                          >|
                            {{
                              job.maximum_remuneration
                                | currency("R$ ", 2, {
                                  decimalSeparator: ",",
                                  thousandsSeparator: ".",
                                })
                            }}</span>
                        </p>
                      </td>
                      <td class="center">
                        <inertia-link :href="`/recruiters/evaluators/jobs/${job.id}/applies`">
                          <span
                            class="pointer alert_small box-danger"
                            role="alert"
                          >{{ job.reproved }}</span>
                          <span
                            class="pointer alert_small box-primary"
                            role="alert"
                          >{{ job.no_avaliation }}</span>
                          <span
                            class="pointer alert_small box-success"
                            role="alert"
                          >{{ job.process }}</span>
                        </inertia-link>
                      </td>
                      <td class="center color-grey">
                        {{ job.created_at | moment("D/MM/Y") }}
                      </td>
                      <td class="center color-grey">
                        {{ job.recruiter_name }}
                      </td>
                    </tr>
                    <div
                      class="center position-absolute loading-gif"
                      :class="{ 'd-none': !loading || firstLoad }"
                    >
                      <img
                        src="/images/loading.gif"
                        alt="loading-gif"
                      />
                    </div>
                  </tbody>
                </table>
                <v-pagination
                  v-model="currentPage"
                  :page-count="pageCount"
                  class="justify-content-center"
                  :class="firstLoad ? 'd-none' : 'd-flex'"
                  :classes="bootstrapPaginationClasses"
                ></v-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>    
  </EvaluatorLayout>
</template>


<script>
import EvaluatorLayout from "layouts/Evaluator.vue";
import OrderTable from "components/OrderTable.vue";

export default {
  components: {
    EvaluatorLayout,
    OrderTable,
  },

  props: {
    selected_job: {
      type: Array,
      required: false,
    }
  },

  mounted() {
    if (this.selected_job?.length > 0) this.jobs = this.selected_job;
  },

  data() {
    return {
      jobs: [],
      jobs_deleted: [],
      loading: false,
      firstLoad: true,
      currentPage: 1,
      pageCount: 0,
      deleted: false,
      field: "",
      order: "",
      status: 1,
      jobs: [],
      bootstrapPaginationClasses: {
        ul: "pagination",
        li: "page-item",
        liActive: "active",
        liDisable: "disabled",
        button: "page-link",
      },
    }
  },


}
</script>